import { http } from "./http";

function normalizeVariables(value) {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => String(item || "").trim())
    .filter(Boolean);
}

function normalizeTemplate(item = {}) {
  return {
    id: item?.id || "",
    templateKey: item?.template_key || item?.templateKey || "",
    name: item?.name || "",
    subject: item?.subject || "",
    htmlContent: item?.html_content || item?.htmlContent || "",
    variables: normalizeVariables(item?.variables),
    description: item?.description || "",
    isActive: Boolean(item?.is_active ?? item?.isActive ?? true),
    createdAt: item?.created_at || item?.createdAt || "",
    updatedAt: item?.updated_at || item?.updatedAt || "",
  };
}

export const EmailTemplatesService = {
  async listTemplates() {
    const res = await http("/api/admin/email-templates");
    const rows = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res)
      ? res
      : [];
    return rows.map(normalizeTemplate);
  },

  async getTemplate(key) {
    const res = await http(`/api/admin/email-templates/${key}`);
    return normalizeTemplate(res?.data || res || {});
  },

 async updateTemplate(key, payload) {
  const res = await http(`/api/admin/email-templates/${key}`, {
    method: "PATCH",
    body: {
      subject: payload?.subject ?? "",
      html_content: payload?.htmlContent ?? payload?.html_content ?? "",
      variables: Array.isArray(payload?.variables) ? payload.variables : [],
    },
  });

  return normalizeTemplate(res?.data || res || {});
}
};

export default EmailTemplatesService;